import axiosInstance from './axios.service';

const userService = {
  updateProfile: async (userId, userData, token) => {
    const { data } = await axiosInstance.put(`/api/users/${userId}`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  },

  getProfile: async (userId, token) => {
    const { data } = await axiosInstance.get(`/api/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  },

  updatePassword: async (userId, oldPassword, newPassword, token) => {
    const { data } = await axiosInstance.put(
      `/api/users/${userId}/password`,
      { oldPassword, newPassword },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  },

  getUsers: async (skip, limit, token) => {
    const { data } = await axiosInstance.get(`/api/users/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  },

  createUser: async (userData, token) => {
    const { data } = await axiosInstance.post('/api/users/', userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  },

  deleteUser: async (userId, token) => {
    const { data } = await axiosInstance.delete(`/api/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  },

  updateLanguage: async (userId, language) => {
    const { data } = await axiosInstance.put(`/api/users/${userId}/language`, { language });
    return data;
  },
};

export default userService;
